import { Fragment } from 'react';
import {
  COMPANY,
  FOLLOW_US,
  FOOTER_BUTTON_SETS,
  FOOTER_COL_SETS,
  FOOTER_DESC,
  QUERY,
} from './dataset';
import { ButtonList, List, MainHead, SubFooter, SubHead } from './utils';

const DefaultFooter = (): JSX.Element => {
  return (
    <div data-testid="Footer">
      <div className="py-20 bg-brand-1000">
        <div className="wg-container">
          <div className="flex gap-4 sm:flex-col">
            <div className=" w-1/4 sm:w-full md:w-2/3">
              <img
                src="https://assets1.cleartax-cdn.com/cleartax/images/1661151661_clear_logo.svg"
                alt="Clear Logo"
                width="153"
                height="28"
              />
              <div className="sm:flex md:gap-4 sm:gap-4">
                <div className="sm:w-1/2">
                  <div className="mt-10">
                    <SubHead text={FOLLOW_US.heading} />
                    <div className="flex gap-2 sm:gap-1">
                      {FOLLOW_US.images.map((follow) => (
                        <a key={follow.imageLink} href={follow.redirectUrl}>
                          <img
                            src={follow.imageLink}
                            alt={follow.altText}
                            width="24"
                            height="24"
                          />
                        </a>
                      ))}
                    </div>
                  </div>

                  <div className="mt-10">
                    <SubHead text={QUERY.heading} />
                    {QUERY.lists.map((list) => (
                      <List key={list.text} text={list.text} link={list.link} />
                    ))}
                  </div>
                </div>

                <div className="mt-10">
                  <MainHead
                    heading={COMPANY.heading}
                    borderBottomRequired={false}
                  />
                  <div className="mt-4">
                    {COMPANY.lists.map((list) => (
                      <List key={list.text} text={list.text} link={list.link} />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              {FOOTER_COL_SETS.map((sec) => (
                <Fragment key={`footerHead_${sec.heading}`}>
                  <MainHead heading={sec.heading} />
                  <div className="flex flex-wrap mb-10">
                    {sec.child.map((item) => {
                      return (
                        <div key={item.id} className="w-3/12 md:w-1/2 sm:w-1/2">
                          <SubHead text={item.subHead} />
                          {item.lists.map((list) => (
                            <List
                              key={`${item.id}_${list.text}`}
                              text={list.text}
                              link={list.link}
                            />
                          ))}
                        </div>
                      );
                    })}
                  </div>
                </Fragment>
              ))}
            </div>
          </div>

          {FOOTER_BUTTON_SETS.map((buttonSet, index) => (
            <Fragment key={index}>
              <MainHead heading={buttonSet.heading} />
              <div className="flex flex-wrap gap-3 mt-6 mb-10">
                {buttonSet.lists.map((list) => (
                  <ButtonList
                    key={list.text}
                    text={list.text}
                    link={list.link}
                  />
                ))}
              </div>
            </Fragment>
          ))}

          <div className="mt-12 pt-6 borderTop">
            {FOOTER_DESC.map((desc) => (
              <p
                key={desc}
                className={`text-s-12 text-justify mb-4 text-grey-500 opacity-70`}
              >
                {desc}
              </p>
            ))}
          </div>

          <SubFooter />
        </div>
      </div>
    </div>
  );
};

export { DefaultFooter };
